import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { QuestionFacade } from '../../facade/question.facade';
import { ClientType } from '../../service/type-detector.service';
import { I18nService } from '../../service/i18n/i18n.service';
import { ContactComponent } from './contact/contact.component';
import { LangSwitcherComponent } from './lang-switcher/lang-switcher.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [ContactComponent, LangSwitcherComponent, AsyncPipe],
})
export class HeaderComponent implements OnInit {
  private readonly titleService = inject(Title);
  private readonly translateService = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly i18nService = inject(I18nService);
  private readonly questionFacade = inject(QuestionFacade);

  language$: Observable<string>;
  websiteUrl: string;
  type: ClientType;

  constructor() {
    this.type = this.questionFacade.state$.value?.type;
  }

  ngOnInit(): void {
    this.websiteUrl = this.getWebsiteUrl(this.translateService.currentLang, this.type);
    this.language$ = this.translateService.onLangChange.pipe(
      map((event) => event.lang),
      startWith(this.translateService.currentLang),
      shareReplay(1),
    );
    this.setPageTitle();
  }

  onLangChanged(lang: string): void {
    this.i18nService.setLanguage(lang);
    this.translateService.use(lang).subscribe(() => {
      this.websiteUrl = this.getWebsiteUrl(lang, this.type);
      this.setPageTitle();
    });
    this.router.navigate([], {
      queryParamsHandling: 'preserve',
    });
  }

  private getWebsiteUrl(lang: string, type: ClientType): string {
    return environment[`WEBSITE_${type.toUpperCase()}_${lang.toUpperCase()}`];
  }

  private setPageTitle(): void {
    this.translateService.get('site.title').subscribe((title: string) => {
      this.titleService.setTitle(title);
    });
  }
}
